import React from "react";

const MediaSocial = () => {
  return (
    <div>
      <div className="header-medsos">
        <p
          style={{ fontSize: "42px", fontWeight: "bold" }}
          className="text-sky-500 mb-10"
        >
          Media Social
        </p>
        <div className="content-medsos flex justify-center flex-wrap gap-20 lg:gap-40 md:gap-20 max-sm:gap-10">
          <div className="medsos">
            <a
              href="https://www.instagram.com/gmfaaaaa/"
              target="_blank"
              rel="noreferrer"
            >
              <i class="cursor-pointer fa-brands fa-instagram text-6xl text-amber-800"></i>
            </a>
          </div>
          <div className="medsos">
            <a
              href="https://www.linkedin.com/in/muhammad-fadillah-abdul-aziz-b4699a238/"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-linkedin text-6xl text-blue-700"></i>
            </a>
          </div>
          <div className="medsos">
            <a
              href="https://github.com/gozzafadillah?tab=repositories"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-github text-6xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaSocial;
